import styled from 'styled-components'
import bg1Img from '../../assets/bg1pc.png'
import Slider from 'react-slick'
function Page1Pc(props) {
  var settings = {
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  let bannerList = props.banner
  return (
    <>
    <MainContainer {...settings}>
      
      {bannerList &&
          bannerList.map((banner, idx) => {
            return (
            <Slide1 
            background={"no-repeat url("+process.env.REACT_APP_BASE_RESOURCES_API + encodeURI(banner?.baFileDto?.filePath)+")"}
            >
            <TextsContainer>
              <Title dangerouslySetInnerHTML={{ __html: banner.baTitle }}></Title>
              <Text1 dangerouslySetInnerHTML={{ __html: banner.baContents }}></Text1>
            </TextsContainer>
          </Slide1>
          )
        })}

    </MainContainer>
    </>
  )
}

export default Page1Pc


const MainContainer = styled(Slider)`
  display: flex;
  flex-direction: column;
  margin-top: 88px;
  max-height: 100vh;
  overflow: hidden;
`


const Slide1 = styled.div`
  height: calc(100vh - 171.7px);
  background: ${(props) => props.background};
  background-size: cover;
`


const Bg = styled.img`
  object-fit: cover;
  z-index: 0;
`
const TextsContainer = styled.div`
  width: 100vw;
  height: calc(100vh - 184px);
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Title = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 29px;
  color: #fff;
  z-index: 300;
  text-align: center;
`
const Eagon = styled.p`
  font-size: 11.3px;
  font-weight: 500;
  color: #fff;
  margin-left: -155px;
  margin-top: -36px;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 16.7px;
  color: #fff;
  z-index: 300;
  text-align: center;
  margin-top: 80px;
  letter-spacing: -0.95px;
`
const Text2 = styled(Text1)``
